import React, { useState, useEffect, useContext, Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link, useHistory } from "react-router-dom";
import * as request from 'request';
import $ from 'jquery';

import FAQ from 'components/FAQ';
import { FirebaseContext } from 'contexts/Firebase';
import {
    BlackCheckoutModal,
    showToastAlert,
    parseURLParams
} from 'Services/Utility';


const ResidentialPage = (props) => {

    const { user, firebase } = useContext(FirebaseContext);
    const history = useHistory();
    const [hasDiscordId, setHasDiscordId] = useState(false);
    const [ispPlans, setIspPlans] = useState({});
    const [checkoutModals, setCheckoutModals] = useState([]);
    const [propFrom, setPropFrom] = useState('');
    const [propHash, setPropHash] = useState('');

    useEffect(() => {

        document.getElementsByTagName('title')[0].innerHTML = 'Buy The Best Rotating Residential Proxies | 100+ million IPs | Stella Proxies';
        document.getElementsByName('description')[0].setAttribute('content', '100+ million IPs. 250000+ successful checkouts. Get your Residential proxies today!');
        document.getElementById('canonical').setAttribute('href', 'https://stellaproxies.com/products/residential-proxies/')

        document.getElementsByName('og:locale')[0].setAttribute('content', 'en_US');
        document.getElementsByName('og:title')[0].setAttribute('content', 'Buy The Best Rotating Residential Proxies | 100+ million IPs | Stella Proxies');
        document.getElementsByName('og:description')[0].setAttribute('content', '100+ million IPs. 250000+ successful checkouts. Get your Residential proxies today!');
        document.getElementsByName('og:url')[0].setAttribute('content', 'https://stellaproxies.com/products/residential-proxies/');
        document.getElementsByName('og:site_name')[0].setAttribute('content', 'Stella Proxies');

        const bsScript = document.createElement('script');
        bsScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.min.js');
        document.getElementsByTagName('html')[0].appendChild(bsScript);
        document.getElementsByTagName('html')[0].style.fontSize = '16px';
        document.getElementsByTagName('body')[0].style.fontFamily = 'Prompt, sans-serif';
        document.body.classList.forEach(x => document.body.classList.remove(x));
        document.body.classList.add('landing-page');

        if (firebase.clearState && props && props.location && props.location.state) {
            props.location.state = {};
            firebase.clearState = false;
        }

        if (props && props.location && props.location.state && props.location.state.from && props.location.state.from != '') {
            setPropFrom(props.location.state.from);
        }
        if (props && props.location && props.location.state && props.location.state.hash && props.location.state.hash != '' && props.location.state.hash != '#') {
            setPropHash(props.location.state.hash);
        }

        $(window).on('resize', function () {
            setTimeout(() => {
                var firstTop = $('#first-circle').offset().top;
                var lastTop = $('#last-circle').offset().top;
                $('.hero .left-hero span').height(`${lastTop - firstTop - 15}px`);
            }, 2000)
        });

        return () => {
            document.getElementsByTagName('html')[0].removeChild(bsScript);
            document.getElementsByTagName('html')[0].removeAttribute('style');
            document.getElementsByTagName('body')[0].removeAttribute('style');
            document.body.classList.remove('landing-page');
        }
    }, []);

    const openCheckoutModal = async (planType, planID, subPlanID) => {
        try {
            setCheckoutModals([]);

            if (!user) {
                history.push('/login');
                return;
            }
            if (!hasDiscordId) {
                return showToastAlert('Error', "Please verify your discord account");
            }

            let plan = ispPlans;
            let planData = plan[planID];
            if (!planData) return;

            setCheckoutModals([
                <BlackCheckoutModal
                    showModal={true}
                    checkoutPlanID={planID}
                    checkoutsubPlanID={subPlanID}
                    checkoutPlanType={planType}
                    planData={planData}
                    key={Math.random()}
                    firebase={firebase}
                />
            ]);
        } catch (error) {
            showToastAlert('Error', error.message);
        }
    }

    const verifyDiscord = async () => {
        let idToken = await firebase.auth.currentUser.getIdToken(true);
        let url = `${window.location.origin}${window.location.pathname}`;
        let state = JSON.stringify({
            'redirect_url': url,
            idToken: idToken
        });
        let discordUrl = `https://discordapp.com/api/oauth2/authorize?client_id=${process.env.REACT_APP_DISCORD_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_API_URL}/discord/callback&response_type=code&scope=identify%20email%20guilds%20guilds.join&state=${state}`;
        window.location.href = discordUrl;
    }

    useEffect(() => {
        props.toggleSideMenu(false);
        (async function () {

            firebase.db.ref('plans/residential').on('value', async (snapshot) => {
                const dbPlans = snapshot.val();
                setIspPlans(dbPlans);

                var firstTop = $('#first-circle').offset().top;
                var lastTop = $('#last-circle').offset().top;
                $('.hero .left-hero span').height(`${lastTop - firstTop - 15}px`);
            });
        })();
    }, []);

    useEffect(() => {
        (async function () {
            firebase.auth.onAuthStateChanged(async (user) => {
                try {
                    if (user) {
                        const discordId = (await firebase.db.ref(`users/${user.uid}/discordId`).once('value')).val();
                        if (discordId && discordId !== '') {
                            setHasDiscordId(true);
                        }
                    }
                } catch (error) {
                    console.log(error);
                    showToastAlert('Error', error.message);
                }
            });
        })();
    }, []);

    useEffect(() => {
        let urlString = window.location.href;
        let urlParams = parseURLParams(urlString);
        let currentUrl = urlString.split('?')[0];
        window.history.replaceState({}, document.title, currentUrl);
        if (urlParams) {
            if (urlParams.status && urlParams.status[0] === 'success') {
                try {
                    showToastAlert('success', 'Discord successfully verified');
                } catch (error) {
                    showToastAlert('Error', 'Error while verifying Discord');
                }
            } else if (urlParams.message) {
                showToastAlert('Error', urlParams.message[0]);
            }
        }
    }, []);


    return (
        <>
            <header className='mb-2'>
                <nav className="navbar navbar-expand-lg navbar-light bg-transparent fixed-top py-3">
                    <div className="container">
                        <a className="navbar-brand" href="/">
                            <img src={require("assets/images/logo.svg")} alt="" />
                        </a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon">
                                <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="32" height="4" rx="2" fill="white" />
                                    <rect y="10" width="32" height="4" rx="2" fill="white" />
                                    <rect y="20" width="32" height="4" rx="2" fill="white" />
                                </svg>
                            </span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto ms-auto mb-2 mb-lg-0">
                                <li className="nav-item mx-2">
                                    <a className="nav-link active" aria-current="page" href="#features">Features</a>
                                </li>
                                <li className="nav-item dropdown mx-2">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Products
                                    </a>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><a className="dropdown-item" href="/products/bulk-proxies">Bulk Proxies</a></li>
                                        <li><a className="dropdown-item" href="/products/isp-proxies">Unlimited ISP Proxies</a></li>
                                        <li><a className="dropdown-item" href="/products/residential-proxies">Residential Proxies</a></li>
                                        <li><a className="dropdown-item" href="/products/sneaker-proxies">Sneaker Proxies</a></li>
                                        <li><a className="dropdown-item" href="/products/nike">Nike</a></li>
                                    </ul>
                                </li>
                                <li className="nav-item mx-2">
                                    <a className="nav-link active" aria-current="page" href="#pricing">Pricing</a>
                                </li>
                                <li className="nav-item mx-2">
                                    <a className="nav-link active" aria-current="page" href="#faq">FAQ</a>
                                </li>
                                <li className="nav-item mx-2">
                                    <a className="nav-link active" aria-current="page" href="/blog">Blog</a>
                                </li>
                            </ul>
                            <div className='d-flex align-items-center' style={{ margin: '10px 15px 10px 0' }}>
                              <a href="https://dash.stellaproxies.com/index.php?rp=/login" className="cta"> ISP Dashboard </a>
                            </div>
                            {
                                user &&
                                <div className='d-flex align-items-center' style={{ gap: '15px' }}>
                                    <a href="/dashboard" className="cta"> Resi Dashboard </a>
                                    {
                                        !hasDiscordId &&
                                        <a href="#" onClick={verifyDiscord}>
                                            <svg width="30" height="30" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M13.5447 2.77046C12.5249 2.30254 11.4313 1.9578 10.2879 1.76035C10.2671 1.75654 10.2463 1.76606 10.2356 1.78511C10.0949 2.03525 9.93915 2.36158 9.83006 2.61808C8.60027 2.43397 7.37679 2.43397 6.17221 2.61808C6.0631 2.35588 5.90166 2.03525 5.76038 1.78511C5.74966 1.7667 5.72886 1.75717 5.70803 1.76035C4.56527 1.95717 3.47171 2.30191 2.45129 2.77046C2.44246 2.77427 2.43488 2.78063 2.42986 2.78887C0.355594 5.88778 -0.212633 8.91052 0.0661201 11.8958C0.0673814 11.9104 0.0755799 11.9244 0.086932 11.9332C1.45547 12.9383 2.78114 13.5484 4.08219 13.9528C4.10301 13.9592 4.12507 13.9516 4.13832 13.9344C4.44608 13.5141 4.72043 13.071 4.95565 12.6049C4.96953 12.5777 4.95628 12.5453 4.92791 12.5345C4.49275 12.3694 4.0784 12.1681 3.67982 11.9396C3.64829 11.9212 3.64577 11.8761 3.67477 11.8545C3.75865 11.7916 3.84255 11.7262 3.92264 11.6602C3.93713 11.6482 3.95732 11.6456 3.97435 11.6532C6.59286 12.8488 9.4277 12.8488 12.0153 11.6532C12.0323 11.645 12.0525 11.6475 12.0677 11.6596C12.1478 11.7256 12.2316 11.7916 12.3161 11.8545C12.3451 11.8761 12.3433 11.9212 12.3117 11.9396C11.9131 12.1726 11.4988 12.3694 11.063 12.5338C11.0346 12.5446 11.022 12.5777 11.0359 12.6049C11.2762 13.0703 11.5505 13.5135 11.8526 13.9338C11.8652 13.9516 11.8879 13.9592 11.9087 13.9528C13.2161 13.5484 14.5417 12.9383 15.9103 11.9332C15.9223 11.9244 15.9298 11.911 15.9311 11.8964C16.2647 8.44512 15.3723 5.44717 13.5655 2.78951C13.5611 2.78063 13.5535 2.77427 13.5447 2.77046ZM5.34668 10.0781C4.55833 10.0781 3.90876 9.35431 3.90876 8.46545C3.90876 7.57659 4.54574 6.85283 5.34668 6.85283C6.15392 6.85283 6.79721 7.58295 6.78459 8.46545C6.78459 9.35431 6.14761 10.0781 5.34668 10.0781ZM10.6632 10.0781C9.87484 10.0781 9.22526 9.35431 9.22526 8.46545C9.22526 7.57659 9.86222 6.85283 10.6632 6.85283C11.4704 6.85283 12.1137 7.58295 12.1011 8.46545C12.1011 9.35431 11.4704 10.0781 10.6632 10.0781Z"
                                                    fill="white" />
                                            </svg>
                                        </a>
                                    }
                                </div>
                            }
                            {
                                !user &&
                                <Link to={{ pathname: 'login', state: { 'from': propFrom, 'hash': propHash } }} className="cta"> Login to Dashboard</Link>
                            }
                        </div>
                    </div>
                </nav>
            </header>

            <section className="hero">
                <div className="container">
                    <div className="row hero-row">
                        <div className="col-6 text-light left-hero">
                            <span></span>
                            <h1 className="fw-bold main-title circle-big" id="first-circle">
                                The Best Residential Proxies
                            </h1>
                            <p className="mt-3 mb-4">
                                Are you looking for a reliable and secure proxy service to protect your sensitive data and keep your geolocation private? Look no further than Stella Residential Proxies. As a leading provider of real IP addresses, our proxies remain undetected by anti-bot providers and offer fast connections with no downtime. Whether you're a company or an individual, our residential proxies provide anonymity and secure online browsing, while allowing you to view blocked or restricted online content. Trust Stella Residential Proxies for all your proxy needs.
                            </p>

                            <div className="btn-pair">
                                {
                                    !user &&
                                    <Link to={{ pathname: 'login', state: { 'from': propFrom, 'hash': propHash } }} className="cta px-5"> Sign In</Link>
                                }
                                <a href="#pricing" className="cta secondary px-4"> View Plans </a>
                            </div>
                        </div>
                        <div className="col-6">
                            <img src={require("assets/images/hero-img.png")} className="img-fluid" alt="" />
                        </div>
                    </div>

                    <div className="four-box mt-5">
                        <div className="box sm-c-line">
                            <h4>100+</h4>
                            <p>Million IPs</p>
                        </div>
                        <div className="box sm-c">
                            <h4>10,000+</h4>
                            <p>Happy Customers</p>
                        </div>
                        <div className="box sm-c">
                            <h4>250,000+</h4>
                            <p>Successful Checkouts</p>
                        </div>
                        <div className="box sm-c last-dif-line">
                            <h4>100%</h4>
                            <p>Satisfaction Guarantee</p>
                        </div>
                    </div>
                </div>

                <div className="container pt-5">
                    <div className="row hero-row mt-3">
                        <div className="col-12 text-light left-hero">
                            <h2 className="fw-bold main-title circle-big">
                                What Are Residential Proxies?
                            </h2>
                            <p className="mt-3">
                                Residential proxies are IP addresses that are authentic addresses borrowed from other users' laptops, desktops, and other IoT devices. With a residential proxy IP, you can hide the IP address associated with your Internet provider when visiting websites or sending sensitive information over the Internet.
                            </p>
                            <p className="mt-3 mb-4">
                                For example, if you visit a website selling furniture and enter your name, address, and credit card number to buy furniture, that information bypasses your provider's IP address, which is readily available to sophisticated hackers who sell such information on the dark web.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container" id='pricing'>
                    <div className="row hero-row mt-5">
                        <div className="col-12">
                            <h2 className="fw-bold main-title circle-big position-relative section-2-custom-set">
                                Pricing
                            </h2>
                        </div>
                    </div>

                    <div className="proxy-network-details pricing-details">
                        <div className="tab-content">
                            <div id="isp" role="tabpanel" aria-labelledby="isp-tab">
                                <div className="row mt-2">
                                    {ispPlans && Object.keys(ispPlans).map(planID => {
                                        if (planID == 'active' || planID == "categories") {
                                            return null;
                                        }
                                        let plan = ispPlans[planID];
                                        if (plan.bulk || plan.hide || plan.onlybot || !plan.topup) return null;
                                        return <PriceCard openCheckoutModal={openCheckoutModal} planType='residential' planData={plan} isActive={ispPlans.active} categories={ispPlans.categories} planID={planID} ></PriceCard>
                                    })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container section-2" id='features'>
                    <div className="row hero-row">
                        <div className="col-12">
                            <h2 className="fw-bold main-title circle-big position-relative section-2-custom-set">
                                Features of Stella Proxies' Residential Proxies
                            </h2>
                        </div>
                    </div>

                    <div className="proxy-network-details pricing-details">
                        <div className="tab-content px-0">
                            <div id="isp" role="tabpanel" aria-labelledby="isp-tab">
                                <div className="row mt-4">
                                    <div className="col-md-6 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-details-part px-4">
                                                <h3>Offers 200,000,000+ Unique IP Addresses in Over 150 Countries</h3>
                                                <p className='mt-4 mb-0'>With our residential proxies, you'll never have to deal with the duplicate or unusable proxies that free or novice residential proxy providers are notorious for sharing. Our proxies are reliable, secure and efficient, ensuring that you get the best service every time. Trust us for all your residential proxy needs and stay away from the unreliable free or novice providers.</p>
                                            </div>
                                            <div className="shadow-box" style={{ backgroundColor: 'var(--purple)' }}></div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-details-part px-4">
                                                <h3>Significantly Improved Connection</h3>
                                                <p className='mt-4 mb-0'>We offer significantly improved connections with no 402 access failures or refused connectivity. Our user-friendly designed dashboard allows you to easily generate or view your proxies, making the process of using a residential proxy service more convenient than ever before. Trust us for all your residential proxy needs and experience a significant improvement in your connection.</p>
                                            </div>
                                            <div className="shadow-box" style={{ backgroundColor: 'var(--purple)' }}></div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-details-part px-4">
                                                <h3>No Downtime</h3>
                                                <p className='mt-4 mb-0'>Thanks to our in-built Upstream system, our residential proxies are designed to never go down, ensuring that they are always available when you need them the most. With our service, you can say goodbye to the frustration of downtimes and say hello to a reliable and efficient residential proxy service.</p>
                                            </div>
                                            <div className="shadow-box" style={{ backgroundColor: 'var(--purple)' }}></div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-details-part px-4">
                                                <h3>Excellent Customer Service</h3>
                                                <p className='mt-4 mb-0'>At Stella Proxies, we understand the importance of providing excellent customer service. That's why our team is available 24/7 via Discord to address any questions or concerns you may have. We pride ourselves on responding quickly and efficiently to any issues that arise, ensuring that our customers receive the support they need. Trust us for all your residential proxy needs and experience top-notch customer service.</p>
                                            </div>
                                            <div className="shadow-box" style={{ backgroundColor: 'var(--purple)' }}></div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-details-part px-4">
                                                <h3>Exceeds Legitimacy, Security, and Reputation Expectations</h3>
                                                <p className='mt-4 mb-0'>A leading global provider of residential proxies, Stella Proxies is the "go to" proxy service for organizations, mid-size businesses, e-commerce owners, and individuals who are concerned about protecting their personal information and identity online.</p>
                                            </div>
                                            <div className="shadow-box" style={{ backgroundColor: 'var(--purple)' }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container pt-5" id='brands'>
                    <div className="row hero-row mt-5">
                        <div className="col-12">
                            <h2 className="fw-bold main-title circle-big position-relative section-2-custom-set">
                                Leading Sneaker Brands That Stella Proxies Serves
                            </h2>
                        </div>
                        <p className="text-white">Our proxies are perfect for any sneaker bot, but some brands we serve better than others</p>
                    </div>

                    <div className="proxy-network-details pricing-details">
                        <div className="tab-content px-0">
                            <div className={`tab-pane fade show active`} id="isp" role="tabpanel" aria-labelledby="isp-tab">
                                <div className="row mt-4">
                                    <div className="col-md-4 mt-4">
                                        <div className="price-box">
                                            <h4 className="text-center fw-bold">Yeezy</h4>
                                            <p>Are you a fan of Yeezys? Whether you're looking to resell them or keep them as personals, these shoes are highly sought-after. But getting your hands on multiple pairs can be difficult, especially when trying to pass the splash page on YeezySupply. That's where captcha proxies with high ReCaptcha scores come in. They are essential to bypassing the splash page and ensuring you don't miss out on the next drop.</p>
                                            <a href="#" className="purchase-btn mt-4">Go To Yeezy</a>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <div className="price-box">
                                            <h4 className="text-center fw-bold">Nike</h4>
                                            <p>Our premium Nike ISPs and Residential proxies will increase your chances in copping! Speed, reliability and clean proxies is what you need. Thousands of Jordan, Off-White and Travis Scott releases have been copped by our users on the Nike site.</p>
                                            <a href="#" className="purchase-btn mt-4">Go To Nike</a>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <div className="price-box">
                                            <h4 className="text-center fw-bold">Supreme</h4>
                                            <p>The streetwear brand Supreme has made a significant impact on the scene and got many of us into this market. If you're looking to improve your chances of success in getting limited edition Supreme items, look no further than our Premium Residential proxies. With over 200,000,000 unique, fast and reliable IP addresses, our proxies can help increase your chances of copping those highly sought-after Supreme items and turn those L's into W's.</p>
                                            <a href="#" className="purchase-btn mt-4">Go To Supreme</a>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <div className="price-box">
                                            <h4 className="text-center fw-bold">Adidas</h4>
                                            <p>Adidas is one of the most popular and recognizable brands in the world of sneakers. From shoes to accessories, Adidas has it all. And if you're looking to cop some Adidas gear, we have you covered. We offer a variety of Adidas proxies that are perfect for use with your bot. Each one is fast, reliable, and designed to avoid detection by bot checkers, so you can rest easy knowing your proxies won't get flagged. Get the Adidas gear you want with our proxies.</p>
                                            <a href="#" className="purchase-btn mt-4">Go To Adidas</a>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <div className="price-box">
                                            <h4 className="text-center fw-bold">Zalando</h4>
                                            <p>Zalando, the biggest online fashion retailer in Europe, offers the hottest and latest clothing and footwear releases. To increase your chances of successfully copping these items, our Premium Residential proxies are the ideal solution. Built with a custom pool specifically designed to pass Zalando's bot protection, these proxies give you an edge in the race to snag the highly sought-after releases. Don't miss out on the latest Zalando drops. Get your hands on our specially designed proxies today.</p>
                                            <a href="#" className="purchase-btn mt-4">Go To Zalando</a>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <div className="price-box">
                                            <h4 className="text-center fw-bold">Footsites</h4>
                                            <p>Footsites, a group of sites that includes Footlocker, Champs, and Dicks Sporting Goods, releases thousands of exclusive sneakers and limited-edition apparel. To improve your chances of getting your hands on these coveted items, our Premium Residential proxies are the ideal solution. They are built with custom pools specifically tailored for all Footsites, allowing you to bypass the site's bot protection and increase your chances of copping the latest releases. Don't miss out on your favorite Footsites drops. Try our Footsites-specific proxies today and cop your drip with ease.</p>
                                            <a href="#" className="purchase-btn mt-4">Go To Footsites</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container section-2 pt-5" id='benefits'>
                    <div className="row hero-row">
                        <div className="col-12">
                            <h2 className="fw-bold main-title circle-big position-relative section-2-custom-set">
                                3 Great Benefits of Residential Proxies
                            </h2>
                        </div>
                    </div>

                    <div className="proxy-network-details pricing-details">
                        <div className="tab-content px-0">
                            <div id="isp" role="tabpanel" aria-labelledby="isp-tab">
                                <div className="row mt-4">
                                    <div className="col-md-12 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-img-part">
                                                <img src={require("assets/images/plane.png")} alt="" />
                                            </div>
                                            <div className="box-details-part px-4">
                                                <h3>City and State Level Targeting</h3>
                                                <p>
                                                    With Stella Proxies, you can access your favourite websites from all around the world through our extensive residential proxy network. Our network covers several hundred locations, giving you the option to target specific state, city, or country geolocations. Whether you need to access a website that is blocked in your area or simply want to browse the internet as if you were located in another part of the world, we have you covered. Trust us for all your residential proxy needs and enjoy unrestricted access to the web.
                                                </p>
                                            </div>
                                            <div className="shadow-box"></div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-img-part">
                                                <img src={require("assets/images/delivery.png")} alt="" />
                                            </div>
                                            <div className="box-details-part px-4">
                                                <h3>Increase Your Success Rate</h3>
                                                <p>
                                                    Providing an Upstream System for both static & rotational proxies means you will benefit from an increased success rate and 99.9% uptime. This allows you to request a new IP address when needed, control session times, and avoid the dreaded CAPTCHAs, IP restrictions, bans, and blocks
                                                </p>
                                            </div>
                                            <div className="shadow-box"></div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-0 mb-4">
                                        <div className="detail-box h-100" style={{ maxWidth: '100%', padding: '0.5rem' }}>
                                            <div className="box-img-part">
                                                <img src={require("assets/images/watch.png")} alt="" />
                                            </div>
                                            <div className="box-details-part px-4">
                                                <h3>Unlimited Concurrent Sessions</h3>
                                                <p>
                                                    Web data scraping is a valuable tool for companies that want to monitor competitor prices, stay on top of SERP tracking, and for verifying ads. Stella Proxies does not charge fees for supplementary concurrent sessions. Customers always enjoy free and unlimited concurrent sessions
                                                </p>
                                            </div>
                                            <div className="shadow-box"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-100" id='faq'>
                    <div className="row hero-row">
                        <div className="col-12">
                            <h2 className="fw-bold main-title circle-big position-relative section-2-custom-set">
                                FAQ
                            </h2>

                            <FAQ 
                                qa={
                                    [
                                        {
                                            question: "What to Consider Before Buying a Residential Proxy?",
                                            answer: (
                                                <p className="mb-0">When choosing a Residential Proxy Provider, consider the following factors: fast and reliable internet connection, personal data protection, location flexibility, wide selection of proxies and competitive pricing. Trust us to provide you with the best service in the market.</p>
                                            )
                                        },
                                        {
                                            question: "What's the Difference Between Residential vs Data Center Proxies?",
                                            answer: (
                                                <p className="mb-0">Data Center Proxies use IP addresses from servers located in data centers, which have large bandwidth capacity to handle multiple IPs simultaneously. However, they may not be as reliable as Residential Proxies due to lack of assigned geolocations. Keep this in mind when choosing the best proxy for your needs.</p>
                                            )
                                        },
                                        {
                                            question: "How to Use Residential Proxies?",
                                            answer: (
                                                <p className="mb-0">Get the flexibility you need with our Residential Proxies, use them on a bot, browser extensions, standalone apps and more. You can find/create your proxies in your dashboard upon purchasing a plan and simply paste your IP address into the program of your choice. Trust us to provide you with the best service and flexibility for your needs.</p>
                                            )
                                        },
                                        {
                                            question: "What Can I Use My Residential Proxies For?",
                                            answer: (<>
                                                <p className="mb-0"><span className='text-white'>Sneaker Shopping</span><br />Getting the latest pair of brand-name sneakers is often difficult because some online retailers may have restrictions on their location and purchase amounts. Residential proxies let you shop in complete anonymity on blocked sites.</p>
                                                <p className="my-3"><span className='text-white'>Botting</span><br />We all know copping high demand items, such as the latest pair of hyped sneakers/console, is often difficult due to online retailers having anti-bot restrictions, flagging up location, purchase amounts and more. Using proxies let you shop in complete anonymity on these sites and will allow you to purchase multiples.</p>
                                                <p className="mb-0"><span className='text-white'>Ad Verification</span><br />Online businesses depend on IP addresses to validate their marketing endeavors and affiliate links. When e-commerce platforms place ads, residential proxies can detect malware, and reveal where and how ads are served.</p>
                                            </>)
                                        },
                                        {
                                            question: "Is a Proxy the Same as an IP Address?",
                                            answer: (
                                                <p className="mb-0">No. A regular IP address is basically like a user's online ID card. All data transfers initiated by a user have that IP address attached to the data. Even if you type in a fake name and fake address on a website, your real name and location can be traced using your regular IP address. Residential proxy addresses keep you safe and anonymous while online.</p>
                                            )
                                        },
                                    ]
                                } />
                        </div>
                    </div>
                </div>

                <div className="container mt-100">
                    <div className="row hero-row">
                        <div className="col-12 position-relative">
                            <h2 className="fw-bold main-title circle-big position-relative section-2-custom-set" id="last-circle">
                                The Best Customer <br /> experience in the industry
                            </h2>

                            <p className="text-light mb-4">24/7 Support via Discord to ensure that all your questions and concerns are
                                answered.
                            </p>

                            <a href="https://discord.gg/QxT3GXQ2NY" target='__blank' className="cta px-5"> Join Discord </a>

                            <img src={require("assets/images/building.png")} alt="" className="building" />
                        </div>
                    </div>
                </div>

                <footer className="mt-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 col-6 c-footer-section">
                                <img src={require("assets/images/logo.svg")} alt="" />
                                <p style={{ color: '#AFB0C8' }} className="mt-3">Copyright © 2023 Stella Proxies. <br /> All rights reserved.</p>
                            </div>
                            <div className="col-md-2 col-6">
                                <h4>Products</h4>
                                <div><a href="/products/isp-proxies">ISP Proxies</a></div>
                                <div><a href="/products/residential-proxies">Residential Proxies</a></div>
                            </div>
                            <div className="col-md-2 col-6">
                                <h4>Legal</h4>
                                <div><a href="/privacy" target='__blank'>Privacy Policy</a></div>
                                <div><a href="/tos" target='__blank'>Terms and Service</a></div>
                                <div><a href="#">Return Policy</a></div>
                            </div>
                            <div className="col-md-2 col-6">
                                <h4>Account</h4>
                                <div><a href="https://dash.stellaproxies.com/index.php?rp=/login">ISP Dashboard</a></div>
                                {
                                    user &&
                                    <div><a href="/dashboard">Resi Dashboard</a></div>
                                }
                                {
                                    !user &&
                                    <>
                                        <div><Link to={{ pathname: '/login', state: { 'from': propFrom, 'hash': propHash } }}> Login to Dashboard</Link></div>
                                        <div><a href="/register">Create Account</a></div>
                                    </>
                                }
                            </div>
                            <div className="col-md-2 col-6">
                                <h4>Connect</h4>
                                <div className="social-icons">
                                    <a href="https://twitter.com/StellaProxies" target='__blank'>
                                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.03344 13.5C11.0697 13.5 14.3722 8.4978 14.3722 4.16124C14.3722 4.02062 14.3691 3.87687 14.3628 3.73624C15.0052 3.27164 15.5597 2.69617 16 2.03687C15.4017 2.30307 14.7664 2.47692 14.1159 2.55249C14.8009 2.14194 15.3137 1.49698 15.5594 0.737178C14.915 1.11904 14.2104 1.38841 13.4756 1.53374C12.9806 1.00771 12.326 0.659411 11.6131 0.542701C10.9003 0.42599 10.1688 0.547367 9.53183 0.888064C8.89486 1.22876 8.38787 1.7698 8.08923 2.42754C7.7906 3.08528 7.71695 3.82308 7.87969 4.52687C6.575 4.46139 5.29862 4.12247 4.13332 3.53207C2.96802 2.94166 1.9398 2.11296 1.11531 1.09968C0.696266 1.82216 0.568038 2.6771 0.756687 3.49073C0.945337 4.30436 1.43671 5.01563 2.13094 5.47999C1.60975 5.46344 1.09998 5.32312 0.64375 5.07061V5.11124C0.643283 5.86943 0.905399 6.60439 1.38554 7.19118C1.86568 7.77797 2.53422 8.18037 3.2775 8.32999C2.7947 8.46209 2.28799 8.48133 1.79656 8.38624C2.0063 9.03829 2.41438 9.60859 2.96385 10.0176C3.51331 10.4265 4.17675 10.6537 4.86156 10.6675C3.69895 11.5807 2.26278 12.0761 0.784375 12.0737C0.522191 12.0733 0.260266 12.0573 0 12.0256C1.5019 12.9892 3.24902 13.5009 5.03344 13.5Z"
                                                fill="white" />
                                        </svg>Twitter</a>
                                    <a href="https://discord.gg/QxT3GXQ2NY" target='__blank'>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13.5447 2.77046C12.5249 2.30254 11.4313 1.9578 10.2879 1.76035C10.2671 1.75654 10.2463 1.76606 10.2356 1.78511C10.0949 2.03525 9.93915 2.36158 9.83006 2.61808C8.60027 2.43397 7.37679 2.43397 6.17221 2.61808C6.0631 2.35588 5.90166 2.03525 5.76038 1.78511C5.74966 1.7667 5.72886 1.75717 5.70803 1.76035C4.56527 1.95717 3.47171 2.30191 2.45129 2.77046C2.44246 2.77427 2.43488 2.78063 2.42986 2.78887C0.355594 5.88778 -0.212633 8.91052 0.0661201 11.8958C0.0673814 11.9104 0.0755799 11.9244 0.086932 11.9332C1.45547 12.9383 2.78114 13.5484 4.08219 13.9528C4.10301 13.9592 4.12507 13.9516 4.13832 13.9344C4.44608 13.5141 4.72043 13.071 4.95565 12.6049C4.96953 12.5777 4.95628 12.5453 4.92791 12.5345C4.49275 12.3694 4.0784 12.1681 3.67982 11.9396C3.64829 11.9212 3.64577 11.8761 3.67477 11.8545C3.75865 11.7916 3.84255 11.7262 3.92264 11.6602C3.93713 11.6482 3.95732 11.6456 3.97435 11.6532C6.59286 12.8488 9.4277 12.8488 12.0153 11.6532C12.0323 11.645 12.0525 11.6475 12.0677 11.6596C12.1478 11.7256 12.2316 11.7916 12.3161 11.8545C12.3451 11.8761 12.3433 11.9212 12.3117 11.9396C11.9131 12.1726 11.4988 12.3694 11.063 12.5338C11.0346 12.5446 11.022 12.5777 11.0359 12.6049C11.2762 13.0703 11.5505 13.5135 11.8526 13.9338C11.8652 13.9516 11.8879 13.9592 11.9087 13.9528C13.2161 13.5484 14.5417 12.9383 15.9103 11.9332C15.9223 11.9244 15.9298 11.911 15.9311 11.8964C16.2647 8.44512 15.3723 5.44717 13.5655 2.78951C13.5611 2.78063 13.5535 2.77427 13.5447 2.77046ZM5.34668 10.0781C4.55833 10.0781 3.90876 9.35431 3.90876 8.46545C3.90876 7.57659 4.54574 6.85283 5.34668 6.85283C6.15392 6.85283 6.79721 7.58295 6.78459 8.46545C6.78459 9.35431 6.14761 10.0781 5.34668 10.0781ZM10.6632 10.0781C9.87484 10.0781 9.22526 9.35431 9.22526 8.46545C9.22526 7.57659 9.86222 6.85283 10.6632 6.85283C11.4704 6.85283 12.1137 7.58295 12.1011 8.46545C12.1011 9.35431 11.4704 10.0781 10.6632 10.0781Z"
                                                fill="white" />
                                        </svg>Discord</a>
                                    <a href="https://www.instagram.com/stellaproxies/" target='__blank'>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8 1.44062C10.1375 1.44062 10.3906 1.45 11.2313 1.4875C12.0125 1.52187 12.4344 1.65313 12.7156 1.7625C13.0875 1.90625 13.3563 2.08125 13.6344 2.35938C13.9156 2.64062 14.0875 2.90625 14.2313 3.27813C14.3406 3.55938 14.4719 3.98438 14.5063 4.7625C14.5438 5.60625 14.5531 5.85938 14.5531 7.99375C14.5531 10.1313 14.5438 10.3844 14.5063 11.225C14.4719 12.0063 14.3406 12.4281 14.2313 12.7094C14.0875 13.0813 13.9125 13.35 13.6344 13.6281C13.3531 13.9094 13.0875 14.0813 12.7156 14.225C12.4344 14.3344 12.0094 14.4656 11.2313 14.5C10.3875 14.5375 10.1344 14.5469 8 14.5469C5.8625 14.5469 5.60938 14.5375 4.76875 14.5C3.9875 14.4656 3.56563 14.3344 3.28438 14.225C2.9125 14.0813 2.64375 13.9063 2.36563 13.6281C2.08438 13.3469 1.9125 13.0813 1.76875 12.7094C1.65938 12.4281 1.52813 12.0031 1.49375 11.225C1.45625 10.3813 1.44688 10.1281 1.44688 7.99375C1.44688 5.85625 1.45625 5.60313 1.49375 4.7625C1.52813 3.98125 1.65938 3.55938 1.76875 3.27813C1.9125 2.90625 2.0875 2.6375 2.36563 2.35938C2.64688 2.07812 2.9125 1.90625 3.28438 1.7625C3.56563 1.65313 3.99063 1.52187 4.76875 1.4875C5.60938 1.45 5.8625 1.44062 8 1.44062ZM8 0C5.82813 0 5.55625 0.009375 4.70313 0.046875C3.85313 0.084375 3.26875 0.221875 2.7625 0.41875C2.23438 0.625 1.7875 0.896875 1.34375 1.34375C0.896875 1.7875 0.625 2.23438 0.41875 2.75938C0.221875 3.26875 0.084375 3.85 0.046875 4.7C0.009375 5.55625 0 5.82812 0 8C0 10.1719 0.009375 10.4438 0.046875 11.2969C0.084375 12.1469 0.221875 12.7313 0.41875 13.2375C0.625 13.7656 0.896875 14.2125 1.34375 14.6562C1.7875 15.1 2.23438 15.375 2.75938 15.5781C3.26875 15.775 3.85 15.9125 4.7 15.95C5.55313 15.9875 5.825 15.9969 7.99688 15.9969C10.1688 15.9969 10.4406 15.9875 11.2938 15.95C12.1438 15.9125 12.7281 15.775 13.2344 15.5781C13.7594 15.375 14.2063 15.1 14.65 14.6562C15.0938 14.2125 15.3688 13.7656 15.5719 13.2406C15.7688 12.7313 15.9063 12.15 15.9438 11.3C15.9813 10.4469 15.9906 10.175 15.9906 8.00313C15.9906 5.83125 15.9813 5.55938 15.9438 4.70625C15.9063 3.85625 15.7688 3.27188 15.5719 2.76562C15.375 2.23438 15.1031 1.7875 14.6563 1.34375C14.2125 0.9 13.7656 0.625 13.2406 0.421875C12.7313 0.225 12.15 0.0875 11.3 0.05C10.4438 0.009375 10.1719 0 8 0Z"
                                                fill="white" />
                                            <path
                                                d="M8 3.89062C5.73125 3.89062 3.89062 5.73125 3.89062 8C3.89062 10.2688 5.73125 12.1094 8 12.1094C10.2688 12.1094 12.1094 10.2688 12.1094 8C12.1094 5.73125 10.2688 3.89062 8 3.89062ZM8 10.6656C6.52813 10.6656 5.33437 9.47188 5.33437 8C5.33437 6.52813 6.52813 5.33437 8 5.33437C9.47188 5.33437 10.6656 6.52813 10.6656 8C10.6656 9.47188 9.47188 10.6656 8 10.6656Z"
                                                fill="white" />
                                            <path
                                                d="M13.2312 3.72818C13.2312 4.25943 12.8 4.68755 12.2719 4.68755C11.7406 4.68755 11.3125 4.2563 11.3125 3.72818C11.3125 3.19692 11.7438 2.7688 12.2719 2.7688C12.8 2.7688 13.2312 3.20005 13.2312 3.72818Z"
                                                fill="white" />
                                        </svg>
                                        Instagram</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

            </section>

            {checkoutModals.map(modal => (
                modal
            ))}
        </>
    )
}

class PriceCard extends Component {

    constructor(props) {
        super(props);
        let stateJson = {
            planType: this.props.planType,
            planData: this.props.planData,
            isActive: this.props.isActive,
            categories: this.props.categories,
            selectedCategory: this.props.selectedCategory,
            planID: this.props.planID,
            subPlanID: '',
            planName: this.props.planData.name,
            features: this.props.planData.features,
            hide: this.props.planData.hide,
            stocksLeft: this.props.stocksLeft || {},
            selectedQty: ''
        };

        if (stateJson.planType === 'gmail') {
            if (!stateJson.planData.quantity) {
                stateJson['hide'] = true;
            }
            else {
                const firstQty = Object.keys(stateJson.planData.quantity).map(x => parseInt(x)).sort((a, b) => a - b)[0];
                stateJson['selectedQty'] = firstQty;
                stateJson['subPlanID'] = firstQty;
                stateJson['price'] = stateJson.planData.quantity[firstQty].price;
                stateJson['isActive'] = stateJson.isActive && stateJson.planData.active && stateJson.planData.notAssigned > 0 && stateJson.planData.notAssigned >= firstQty;
            }
        }
        else if (stateJson.planType === 'server') {
            stateJson['hide'] = stateJson.planData.hide || false;
            stateJson['isActive'] = stateJson.isActive && stateJson.planData.active && stateJson.stocksLeft >= parseFloat(stateJson.planData.price);
            stateJson['selectedCategory'] = stateJson.planData.category;
            stateJson['price'] = stateJson.planData.price;
        }
        else {
            let subPlans = {};
            let categories = {};
            for (const subplanId in stateJson.planData.subPlans) {
                const subplan = stateJson.planData.subPlans[subplanId];
                if (!subplan.hide) {
                    subPlans[subplanId] = subplan;
                    categories[subplan.category] = stateJson.categories[subplan.category];
                }
            }
            stateJson.planData.subPlans = subPlans;
            stateJson.categories = categories;
            const subPlanKeys = Object.keys(subPlans);
            if (subPlanKeys.length) {
                stateJson['subPlanID'] = subPlanKeys[0];
                stateJson['price'] = subPlans[subPlanKeys[0]].price;
                stateJson['selectedCategory'] = subPlans[subPlanKeys[0]].category;

                if (stateJson.planType === 'residential') {
                    stateJson['isActive'] = stateJson.isActive && stateJson.planData.active && subPlans[subPlanKeys[0]].active;
                } else {
                    stateJson['isActive'] = stateJson.isActive && stateJson.planData.active && subPlans[subPlanKeys[0]].active && stateJson.stocksLeft[stateJson.planData['servername']] >= subPlans[subPlanKeys[0]].numberOfProxies;
                }
            }
            else {
                stateJson['hide'] = true;
            }
        }

        this.state = stateJson;
        this.onSubPlanChange = this.onSubPlanChange.bind(this);
        this.purchaseInit = this.purchaseInit.bind(this);
    }

    onSubPlanChange(event) {
        let subid = event.target.value;
        let isactive = false;
        if (this.state.planType === 'gmail') {
            isactive = this.props.isActive && this.state.planData.active && this.state.planData.notAssigned > 0 && this.state.planData.notAssigned >= subid;
            this.setState(state => ({
                price: this.state.planData.quantity[subid].price,
                selectedQty: subid,
                subPlanID: subid,
                isActive: isactive
            }));
        }
        else {
            if (this.state.planType === 'residential') {
                isactive = this.props.isActive && this.state.planData.active && this.state.planData.subPlans[subid].active;
            } else {
                isactive = this.props.isActive && this.state.planData.active && this.state.planData.subPlans[subid].active && this.state.stocksLeft[this.state.planData['servername']] >= this.state.planData.subPlans[subid].numberOfProxies;
            }
            this.setState(state => ({
                price: this.state.planData.subPlans[subid].price,
                subPlanID: subid,
                selectedCategory: this.state.planData.subPlans[subid].category,
                isActive: isactive
            }));
        }
    }

    purchaseInit() {
        this.props.openCheckoutModal(this.state.planType, this.state.planID, this.state.subPlanID);
    }

    render() {
        const { hide } = this.state;
        if (hide) {
            return ''
        }
        else {
            return (
                <div className="col-md-4 mt-4">
                    <div className="price-box">
                        <h2 className="text-center fw-bold">{this.state.planName}</h2>

                        <div className="main-price" style={{ fontWeight: 500 }}>${this.state.price}
                            {
                                this.state.planType !== 'gmail' &&
                                <span style={{ fontWeight: 300, fontSize: '0.69rem' }}> / {this.state.categories[this.state.selectedCategory].name}</span>
                            }
                        </div>

                        <div className="price-feature">
                            <ul className="bullet mt-4 mb-0">
                                {ReactHtmlParser(this.state.features)}
                            </ul>
                        </div>

                        <div className="plan-select mt-4">
                            {
                                this.state.planType !== 'gmail' && this.state.planType !== 'server' &&
                                <select id="inputState" className="form-select" value={this.state.subPlanID} onChange={this.onSubPlanChange}>
                                    {Object.keys(this.state.planData.subPlans).map((subId) => {
                                        let subplan = this.state.planData.subPlans[subId];
                                        if (subplan.hide) { return; }
                                        if (this.state.planType === 'residential') {
                                            return <option value={subId}>{`${parseInt(subplan.dataLimitMB) / 1000} GB`}</option>
                                        } else {
                                            if (subplan.category == this.state.selectedCategory) {
                                                return <option value={subId} >{subplan.numberOfProxies} Proxies</option>
                                            }
                                        }
                                    })}
                                </select>
                            }
                            {
                                this.state.planType === 'gmail' &&
                                <select id="inputState" className="form-select" value={this.state.selectedQty} onChange={this.onSubPlanChange}>
                                    {Object.keys(this.state.planData.quantity).map((qty) => {
                                        return <option value={qty}>{qty} Accounts</option>
                                    })}
                                </select>
                            }
                        </div>

                        {this.state.isActive ? <a href="#" className="purchase-btn mt-4" onClick={this.purchaseInit}>Purchase</a> :
                            <a href="#" className="purchase-btn mt-4 bg-secondary" style={{ cursor: 'not-allowed' }}>Sold Out</a>}
                    </div>
                </div>
            )
        }
    }
}

export default ResidentialPage;